import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Country Article Types',
  basePath: '/country-articletype',
  columns: [
    { key: 'articletype_name', label: 'Article Type', sortable: true },
  ],
  fields: [
    { key: 'articletype_pid', label: 'Article Type', type: 'async-select',
      optionsUrl: '/articletypes/options', required: true },
  ],
  defaultSort: { field: 'articletype_name', dir: 'asc' },
});
